/**
 * PWA prompt components for install, update, and offline-ready notifications.
 */

import { usePWA } from '@/hooks/usePWA';
import { Button } from '@/components/ui/button';
import { X, Download, RefreshCw, WifiOff } from 'lucide-react';

export function PWAPrompts() {
  const {
    needRefresh,
    offlineReady,
    canInstall,
    updateServiceWorker,
    installApp,
    dismissInstall,
  } = usePWA();

  if (offlineReady) {
    return (
      <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-slate-800 border border-customer/30 rounded-lg p-4 shadow-xl z-50">
        <div className="flex items-start gap-3">
          <WifiOff className="h-5 w-5 text-customer-400 mt-0.5 shrink-0" />
          <div className="flex-1">
            <p className="text-sm font-medium text-white">
              Ready for offline use
            </p>
            <p className="text-xs text-slate-400 mt-1">
              You can now browse products without internet
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (needRefresh) {
    return (
      <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-slate-800 border border-amber-500/30 rounded-lg p-4 shadow-xl z-50">
        <div className="flex items-start gap-3">
          <RefreshCw className="h-5 w-5 text-amber-400 mt-0.5 shrink-0" />
          <div className="flex-1">
            <p className="text-sm font-medium text-white">
              Update available
            </p>
            <p className="text-xs text-slate-400 mt-1">
              A new version is ready to install
            </p>
            <Button
              size="sm"
              className="mt-3"
              onClick={updateServiceWorker}
            >
              Update now
            </Button>
          </div>
        </div>
      </div>
    );
  }

  if (canInstall) {
    return (
      <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-slate-800 border border-customer/30 rounded-lg p-4 shadow-xl z-50">
        <button
          onClick={dismissInstall}
          className="absolute top-2 right-2 text-slate-400 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>
        <div className="flex items-start gap-3">
          <Download className="h-5 w-5 text-customer-400 mt-0.5 shrink-0" />
          <div className="flex-1">
            <p className="text-sm font-medium text-white">
              Install CaribbeanLeaf
            </p>
            <p className="text-xs text-slate-400 mt-1">
              Add to your home screen for quick access
            </p>
            <Button
              size="sm"
              className="mt-3"
              onClick={installApp}
            >
              Install
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
